import React from 'react';

import AdvisorDashboardContainer from './AdvisorDashboardContainer';

const FreeUserDashboardContainer = () => {
  return <AdvisorDashboardContainer isFreeUser />;
};

export default FreeUserDashboardContainer;
